// Simple event emitter for global errors
type ErrorEventData = {
  title?: string;
  description: string;
};

type ErrorListener = (data: ErrorEventData) => void;

let listeners: ErrorListener[] = [];

export const errorEvents = {
  emit(description: string, title: string = "Error Occurred") {
    listeners.forEach((listener) => listener({ description, title }));
  },
  subscribe(listener: ErrorListener) {
    listeners.push(listener);
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },
};
